module.exports = __webpack_public_path__ + "img/leftSwitch.9abf76d7.png";